
// @ts-nocheck

import { defineComponent } from 'vue';
import { nextTick } from 'vue'

import {getParameterByName, ampLogInfo} from './util'

import LayerStateCalifornia from './components/LayerStateCalifornia.vue';
import LayerStateColorado from './components/LayerStateColorado.vue';
import LayerStateConnecticut from './components/LayerStateConnecticut.vue';
import LayerStateDelaware from './components/LayerStateDelaware.vue';
import LayerStateIowa from './components/LayerStateIowa.vue';
import LayerStateMontana from './components/LayerStateMontana.vue';
import LayerStateNebraska from './components/LayerStateNebraska.vue';
import LayerStateNewHampshire from './components/LayerStateNewHampshire.vue';
import LayerStateNewJersey from './components/LayerStateNewJersey.vue';
import LayerStateOregon from './components/LayerStateOregon.vue';
import LayerStateTennessee from './components/LayerStateTennessee.vue';
import LayerStateTexas from './components/LayerStateTexas.vue';
import LayerStateUtah from './components/LayerStateUtah.vue';
import LayerStateVirginia from './components/LayerStateVirginia.vue';

import LayerOne from './components/LayerOne.vue';
import LayerTwo from './components/LayerTwo.vue';
import LayerThree from './components/LayerThree.vue';
import LayerNoConsent from './components/LayerNoConsent.vue';

export default defineComponent({
  name: 'App',
  components: {
    LayerOne,
    LayerTwo,
    LayerThree,
    LayerNoConsent,
    LayerStateCalifornia,
    LayerStateColorado,
    LayerStateConnecticut,
    LayerStateDelaware,
    LayerStateIowa,
    LayerStateMontana,
    LayerStateNebraska,
    LayerStateNewHampshire,
    LayerStateNewJersey,
    LayerStateOregon,
    LayerStateTennessee,
    LayerStateTexas,
    LayerStateUtah,
    LayerStateVirginia

  },

  props: {
    cmpApi: Object,
    tcModel: Object,
    storeTCString: Function,
    storeAcceptAllTCString: Function,
    storeRejectAllTCString: Function,
    reopenLayer: String,
    initialLayer: String,
    initialVisible: Boolean,
    disclosedVendorIds: Array,
  },  

  
  data() {
      return {
        view : "close",
        visible : false,
        forcedFixedPosition : false,

        styleObject: {
          margin: '0 auto',
          position: 'absolute',
          top: '10px',
          boxSizing: 'border-box'
        }

      }
    },

  mounted() {

    // @ts-ignore
    this.view = this.initialLayer;

    // @ts-ignore
    this.visible = this.initialVisible;

    // @ts-ignore
    if ( this.view == "layerNoConsent" ) {
      
    // @ts-ignore
        this.styleObject = {
          position: 'absolute',
          top: '50%',
    // @ts-ignore
          left: '50%',
          bottom: 'inherit',
          right: 'inherit',
          transform: 'translate(-50%,-50%)',
          height:'inherit',
          overflow:'hidden'
        };


    }

    // @ts-ignore
    // console.log( "App: mounted() view=" + this.view );
    
    nextTick( () => { this.handleChangeView( this.view ) } );

    // // @ts-ignore
    // this.visible = this.$root.initialLayer == "close"  ? false: true;
    
    // let bodyTag = document.getElementsByTagName("body")[0];

    // // @ts-ignore
    // if ( this.visible)
    //  setTimeout( () => { window.scrollTo(0, 0); }, 250 );
    //   // bodyTag.style.cssText = "height: 100%; overflow: hidden";
  },

  // beforeDestroy() {
  //   console.log( "App: beforeDestroy()" );
  // }
  methods:{

    openCMP( ) : void {
      // console.log("App: openCMP()");
      this.handleChangeView( this.reopenLayer );
    
    },

    handleStoreTCString(  ) : void {

      console.log( "App: handleStoreTCString() called" );

      const disclosedIds = this.__getDisclosedVendorIds();
      console.log( "App: disclosedIds count =", disclosedIds ? disclosedIds.length : 0);
      // @ts-ignore
      this.storeTCString(disclosedIds);
      console.log( "App: storeTCString() completed" );
    },

    handleStoreAcceptAllTCStringEvent(  ) : void {
      const disclosedIds = this.__getDisclosedVendorIds();
      // @ts-ignore
      this.storeAcceptAllTCString(disclosedIds);
    },


    handleStoreRejectAllTCString(  ) : void {
      const disclosedIds = this.__getDisclosedVendorIds();
       // @ts-ignore
       this.storeRejectAllTCString(disclosedIds);
    },

    handleChangeView( viewDestination : string ) : void {
      ampLogInfo( "App: handleChangeView() = > " + viewDestination );
      let bodyTag = document.getElementsByTagName("body")[0];
      // console.log("App handleChangeView():");


      if (viewDestination == "close" ) {
  			// bodyTag.style.overflow =  "initial";
  			// bodyTag.style.height =  "initial";

        // @ts-ignore
        this.cmpApi.setCmpDisplayStatus( "hidden" );
        // @ts-ignore
        this.cmpApi.setSignalStatus( "ready" );

        this.visible = false;
      } else {

  			// bodyTag.style.overflow =  "hidden";
        // bodyTag.style.height =  "100%";
        window.scrollTo(0, 0);
        setTimeout( () => { window.scrollTo(0, 0); }, 250 );

        // @ts-ignore
        let setHeight = () => {
          const element = document.getElementById("__cmp_body");
          if (!element) {
            return;
          }
          element.style.maxHeight = ( viewDestination == "layerOne" ) ? "960px" : "98vh";
        };

        // @ts-ignore
        if (this.visible){
          setHeight ();
        }else {
          // @ts-ignore
          this.visible = true;
          this.$nextTick ( setHeight );
        }
        // @ts-ignore
        this.view = viewDestination;
        this.cmpApi.setCmpDisplayStatus( "visible" );

        // signalStatus must be "not ready" while the CMP UI is visible
        
        // @ts-ignore
        this.cmpApi.setSignalStatus( "not ready" );
      }
    },
    __getDisclosedVendorIds(): number[] | null {
      // 1) comes from props
      // @ts-ignore
      if (Array.isArray(this.disclosedVendorIds) && this.disclosedVendorIds.length) {
        // @ts-ignore
        return this.disclosedVendorIds.map((v) => Number(v)).filter((v) => Number.isFinite(v) && v > 0);
      }

      // 2) is some layer set globally
      // Ex: window.__cmpSetDisclosedVendorIds([...]) stored at main
      // fallback
      return null;
    },

    __markDisclosedVendorIds(ids: number[] | null) {
      if (Array.isArray(ids) && ids.length && typeof window.__cmpSetDisclosedVendorIds === 'function') {
        window.__cmpSetDisclosedVendorIds(ids);
      }
    },
  }
});
